import styled, { css } from 'styled-components';

export const Content = styled.input`
  width: ${(props) => props.width};
  text-align: center;
  font-size: 13px;
  line-height: normal;
  border: 0;
  border-left: 1px solid #3d4952;
  background-color: #10151a;
  color: #e6eaec;
  height: 30px;
  outline: none;
  transition: box-shadow 0.15s ease-in-out;
  &::placeholder {
    color: #5a666d;
  }
  &:focus {
    box-shadow: inset 0 0 0 1px #47b972;
  }
  ${(props) =>
    props.$error &&
    css`
      color: #d63a46;
      box-shadow: inset 0 0 0 1px #cc2936;
    `}
`;
